import { StyleSheet } from "react-native";
import { Colors } from "react-native-paper";
import { pixelDimensions } from "../../../config/utils";

const styles = StyleSheet.create({
    buttonArrowBack: {
        position: 'absolute',
        left: pixelDimensions(5),
        height: pixelDimensions(10),
        width: pixelDimensions(10),
        justifyContent: "center",
        alignItems: "center",
        borderRadius: pixelDimensions(100)
    },
    buttonGreen: {
        width: pixelDimensions(80),
        
        paddingHorizontal: pixelDimensions(6),
        marginVertical: pixelDimensions(2),
        paddingVertical: pixelDimensions(2),
    },
    iconArrowBack: {
        fontSize: pixelDimensions(10),
        color: Colors.white
    },
    iconGo: {
        color: Colors.white,
        fontSize: pixelDimensions(10)
    },
    content: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        padding: pixelDimensions(2)
    },
    header: {
        paddingVertical: pixelDimensions(5),
        justifyContent: "center",
        backgroundColor: Colors.indigo700
    },
    imageCoinBank: {
        height: pixelDimensions(30), 
        width: pixelDimensions(30, 79/83)
    },
    scrollview: {
        width: pixelDimensions(90)
    },
    textButtonGreen: {
        textAlign: "center",
        color: Colors.white,
        fontSize: pixelDimensions(5)
    },
    textBalance: {
        color: Colors.white,
        paddingHorizontal: pixelDimensions(3),
        fontSize: pixelDimensions(3.5)
    },
    textBalanceNumber: {
        color: Colors.white,
        fontSize: pixelDimensions(6)
    },
    textPromItem: {
        textAlign: 'center',
        fontSize: pixelDimensions(4),
        color: Colors.white
    },
    textPromItemSmaller: {
        fontSize: pixelDimensions(3),
    },
    textPromItemBigger: {
        fontSize: pixelDimensions(7),
    },
    textTitle: {
        fontSize: pixelDimensions(5),
        color: Colors.white,
        textAlign: "center"
    },
    viewCoinBalance: {
        backgroundColor: Colors.indigo700,
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: pixelDimensions(2),
        marginVertical: pixelDimensions(4),
    },
    viewCoinSubBalance: {
        borderLeftColor: Colors.white,
        borderLeftWidth: 2,
        alignItems: "center"
    },
    viewBase: {
        flex: 1,
        backgroundColor: Colors.grey300
    },
    viewPromItem: { 
        paddingVertical: pixelDimensions(2),
        paddingHorizontal: pixelDimensions(4),
        marginBottom: pixelDimensions(2),
        justifyContent: 'center', 
        alignItems: 'center', 
        flexDirection: 'row', 
        
    },
    viewPromItemTextContainer: {
        flex: 2, 
    },
    viewCentered: {
        flex: 1, 
        justifyContent: 'center', 
        alignItems: 'center'
    }
})

export default styles;